import { Controller } from "stimulus";

// Connects to data-controller="toggle-containers"
// This controller toggles the visibility of two containers
export default class extends Controller {
  static targets = ["scrollContainer"];

  connect() {
    console.log("ToggleContainersController connected");
  }

  toggle() {
    this.scrollContainerTarget.style.display = 
      this.scrollContainerTarget.style.display === "none" ? "block" : "none";
  }
}